import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../common/services/common.service';
import { DataService } from '../../../core/data/data-service';
import { SegmentsService } from '../../../core/routing/services/asset-library/segments.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { AssetLibraryConstants } from './../../../core/routing/services/asset-library/constants/asset-library.constant';
import {
  Segment, CreateSegmentsResponse, SegmentsGroupPage, SegmentsConfiguration, SegmentViewModel,
  ContentGroup, SelectedContGrpsForProfile
} from './interfaces/segments.i';
import { Utils } from '../../../common/utils/utils';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { ProfileRequest, Segment as ProfileSegment, ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { SendToStoreService } from '../../../core/routing/services/asset-library/send-to-store.service';
import { LanguageConstants } from '../../header/constants/lang.consts';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'iposcen-segments',
  templateUrl: './segments.component.html',
  styleUrls: ['./segments.component.scss']
})
export class SegmentsComponent implements OnInit, OnDestroy {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('sendToAccountModal') sendToAccountModal: ElementRef;
  @ViewChild('page1') page1: PageComponent;
  @ViewChild('page2') page2: PageComponent;
  @ViewChild('page3') page3: PageComponent;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  isPolish = localStorage.getItem('preferredLanguage') === 'pl';
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  tabIndex = 0;
  segmentsGroups: Segment[];
  displaySegmentGroups = [];
  selectedFiles: FileList;
  sortValue = AssetLibraryConstants.SORT_ORDER_SEGMANT_NAME_LABEL;
  segmentsData: Segment;
  // TODO create object
  page = 1;
  pageSize = 5;
  maxSize = 5;
  color = '#ffffff';
  contentGrpData: any;
  pageType = GlobalConstants.SEGMENTS;
  segmentToDelete: string;
  segmentToDeleteName: string;
  segmentHeading: string;
  pages: any;
  mediaObjects: any[] = [];
  segmentLayout = 1;
  clickable = false;
  editCheck: boolean;
  disabled: boolean;
  pageGrpForm: any;
  showSegmentName: string;
  sendNameToStore: string;
  sendButtonText: string;
  isRetailerUser: boolean;
  retailHQUser: string;
  segmentIdInfo: string;
  isSendToStore = false;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  presentPage: string;
  profilePage: string = GlobalConstants.PROFILE;
  assetsPage: string = GlobalConstants.ASSET_LIBRARY;
  lockContentText = GlobalConstants.CONTENT_LOCKED;
  isStoreUser: boolean;
  selctedContGrpsForProfile: SelectedContGrpsForProfile = {
    contentGrps: [],
    showOnDevice: false
  };
  buttonName: string;
  showDevice = false;
  isNavigated = false;
  details = ' Details';
  newContentGrpDataToNavigate: any;
  newSegmentTitle: string = $localize`:@@segments.segment-title-tab.new-segment:NEW SEGMENT`;
  profileDataSet: ProfileRequest;
  profileSegmentContentData: ProfileSegment[];
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  addToPackageLimit = GlobalConstants.SEGMENT_ADD_TO_PACKAGE_LIMIT;
  segmentName = AssetLibraryConstants.SORT_ORDER_SEGMANT_NAME_LABEL;
  retailerName = AssetLibraryConstants.SORT_ORDER_RETAILER_NAME_LABEL;
  tooltipDelete = GlobalConstants.DELETE;
  edit = GlobalConstants.EDIT;
  tooltipSendtoStores = GlobalConstants.OPTIONAL_TOOLTIP;
  isPage3Created: boolean;
  changePlacement: boolean;
  globConst = GlobalConstants;
  isIdleExperienceEnabled:string = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  isCheckedPreview: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  pageError = new Map([[1, false], [2, false], [3, false]]);
  buttonLable = GlobalConstants.OK_BUTTON;
  errorMessageText = GlobalConstants.PAGE_ERROR_MESSAGE;
  errorMessageText1 = GlobalConstants.PAGE_ERROR_MESSAGE1;
  errorMessageText2 = GlobalConstants.PAGE_ERROR_MESSAGE2;
  errorMessageText3 = GlobalConstants.PAGE_ERROR_MESSAGE3;
  errorMessageText4 = GlobalConstants.PAGE_ERROR_MESSAGE4;
  errorMessageText5 = GlobalConstants.PAGE_ERROR_MESSAGE5;
  errorMessageText6 = GlobalConstants.PAGE_ERROR_MESSAGE6;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  // TODO - Sandeep to check with neeraj for page n pagesize
  isRegionalHQ: boolean;
  isSegmentNone: boolean;
  deviceExists: boolean;
  whichPageDelete
  pagelen: number;
  previewType:string;
  showPreviewLayout: boolean;

  constructor(private router: Router,
    private segmentsService: SegmentsService,
    private cmnService: CommonService,
    private dataService: DataService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private sendToStoreService: SendToStoreService,
    private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.isCheckedPreview = true;
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    if (this.profileStoreService.currentWorkingProfile) {
      this.profileDataSet = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    }
    this.cmnService.pageObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      if(data.media.format === 'video/mp4' && ((data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS && data.fullScreenCheckbox) || (data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE && data.idleExpFullscreenEnabled))) {
        this.showPreviewLayout = false;
      } else {
        this.showPreviewLayout = true;
      }
    });
    this.getAllSegmentsByUser();
    this.pages = {};
    this.disabled = true;
    this.editCheck = false;
    this.segmentIdInfo = '';
    this.retailHQUser = sessionStorage.getItem('userRole');
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser') || false;
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ') || false;
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER) || false;
    // dummy data to preview page
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        // console.log(res);
        // pages data. To-Do: update to common object ;
        // const updatePromoContent: CreatePromoContentResponse = this.contentGrpData as CreatePromoContentResponse;
        // Once page is updated.
        const segment = this.contentGrpData.segment;
        // console.log(logoContent.configurations,"...ss")
        const configurations = segment.configurations;
        if (res.data.media.url !== '') {
          this.prepareMediaSet(res, segment.id);
        }
        const checkJson = this.checkExistance(configurations.contentGroupPages, 'pageNum', res.number);
        // console.log(checkJson);
        if (checkJson.hasMatch) {// If there is configuration object already for the page number
          // Update the pages
          configurations.contentGroupPages[checkJson.matchedIndex] = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            previewType: res.data.previewType,
            idleExpFullscreenEnabled: res.data.idleExpFullscreenEnabled,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
        } else {
          const segmentGroupPage: SegmentsGroupPage = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            previewType: res.data.previewType,
            idleExpFullscreenEnabled: res.data.idleExpFullscreenEnabled,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
          configurations.contentGroupPages.push(segmentGroupPage);
        }
        this.contentGrpData.segment = segment;
      });

    // set presentpage
    const currentdetailPage = this.router.url;
    const pageName = currentdetailPage.lastIndexOf('/');
    if (currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
  }
  openPopup(modal) {
    this.modalService.open(modal);
  }
  getPageError(data) {
    this.pageError.set(data[1], data[0])
  }
  resetPage() {
    this.pageError = new Map([[1, false], [2, false], [3, false]]);
  }
  goToErrorPage() {
    if (this.pageError.get(1) === true) {
      this.tabIndex = 2
    } else if (this.pageError.get(2) === true) {
      this.tabIndex = 3
    } else {
      this.tabIndex = 4
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getAllSegmentsByUser() {
    // console.log('In component, My userid:: ' + sessionStorage.getItem('userId'));

    this.segmentsService.getAllSegmentsByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllLogoContentResponse => {

        this.segmentsGroups = (getAllLogoContentResponse.segment as Segment[]);
        this.displaySegmentGroups = [];
        this.isSegmentNone = true;
        this.segmentsGroups.forEach(ele => {
          //adding try to bypass breaking because of manual data. specially in dev.
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displaySegmentGroups.push(ele);
        });
        this.displaySegmentGroups.forEach(element => {
          element.isExpanded = false;
          element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          // if deleting make it true
          element.isDeleted = false;
          if (element && element.configurations && element.configurations.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          this.segmentHeading = this.displaySegmentGroups.length <= 1 ? GlobalConstants.SEGMENT_I18N : GlobalConstants.SEGMENTS_I18N;
          if (this.presentPage === GlobalConstants.PROFILE) {
            element.showOnDevice = false;
            element.addToPackage = false;
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredUnChangedContentdata(element);
          // converting date format:
          if (element && element.configurations) {
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
              //changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              //changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
          }
        });
        this.sortBy(GlobalConstants.CREATED_DATE);
        if (this.presentPage === this.profilePage) {
          this.selctedContGrpsForProfile = {
            contentGrps: []
          };
          this.prefillProfileData();
          this.displaySegmentGroups.forEach((element, index) => {
            element.index = index;
            if (this.isSegmentNone) {
              this.isSegmentNone = !element.showOnDevice;
            }
          });
          //TODO MULTIPLE CONDITIONS
          if (this.showDevice) {
            let logCont = this.displaySegmentGroups
              .filter(a => a.addToPackage === true)
              .sort((a, b) => new Date(a.updateTime).getTime() - new Date(b.updateTime).getTime());
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.SEGMENT_CONTENT_GRP_MAX_IN_PACKAGE) {
              this.setPackageNshowOnDeviceVal(logCont[0].index, false);//if limit reached. set values to false since we are de-selecting
            }
            if (this.selctedContGrpsForProfile.showOnDevice) {
              this.findIndexAndSetValue(GlobalConstants.DISPLAY_SEGMENTS, GlobalConstants.ID, false);//de-select in display logo content
              this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.SEGMENT_ID, false);//de-select in selectedCntGrps
            }
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.SEGMENT_CONTENT_GRP_MAX_IN_PACKAGE) {//Since maximum limit reached remove the earliest created one
              this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
                .filter(a => a.segmentId !== logCont[0].id);
            }
            this.displaySegmentGroups[0].addToPackage = true;// add to package/showondevice since selected yes on pop-up
            this.displaySegmentGroups[0].showOnDevice = true;
            this.pushToSelectedGrps(0);
            this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[0].id;
            //update back to profile/ and profile store
            this.createProfileService.updateProfile(
              this.profileDataSet?.profileId, { segments: this.selctedContGrpsForProfile.contentGrps }
            )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
              });
          }
        }


      },
        error => {
          // do something
        }
      );
  }

  changeLockContentStatus(id: string, eventObj: any, object: []) {
    const status = eventObj.target.checked ? GlobalConstants.LOCK_CONTENT_LOCK : GlobalConstants.LOCK_CONTENT_UNLOCK;
    this.cmnService.changeLockContentStatus(id, status, AssetLibraryConstants.SEGMENTS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
        this.displaySegmentGroups[this.displaySegmentGroups.indexOf(object)].islocked = eventObj.target.checked;
      });
  }

  prefillProfileData() {
    // for edit profile -  segment tab
    const existingProfileData = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    if (existingProfileData && (existingProfileData?.profileId === this.createProfileService.getProfileId())) {
      this.profileDataSet = existingProfileData as ProfileRequest;
      this.profileSegmentContentData = this.profileDataSet.segments;
      if (this.profileSegmentContentData?.length) {
        this.selctedContGrpsForProfile = {
          contentGrps: []
        };
        this.displaySegmentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
        if (existingProfileData?.segments?.length === 1 && !existingProfileData?.segments[0].showOnDevice && existingProfileData?.segments[0].segmentId === undefined) {
          this.selctedContGrpsForProfile.contentGrps = [];
        } else {
          this.selctedContGrpsForProfile.contentGrps = existingProfileData.segments;
        }
        this.selctedContGrpsForProfile.contentGrps.forEach((ele, ind) => {
          const contentIdInd = this.displaySegmentGroups.findIndex(each => each.id === ele.segmentId);
          if (contentIdInd >= 0) {
            this.displaySegmentGroups[contentIdInd].addToPackage = true;
            this.displaySegmentGroups[contentIdInd].showOnDevice = ele.showOnDevice;
            if (ele.showOnDevice) {
              this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[contentIdInd].id;
            }
          }
        });
      }
    }
  }

  getDetailsOfSegment(id: string) {
    this.displaySegmentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        this.cmnService.scrollToBottom(id);
      }
    });
    this.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  }

  openPopupSeg(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }

  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.updated(undefined,undefined,'',1);
    }
    let configurations;
    let updatedPages = [];
    
    if (typeof this.contentGrpData.segment.configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData.segment.configurations) as SegmentsConfiguration;
    } else {
      configurations = this.contentGrpData.segment.configurations as SegmentsConfiguration;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    if (this.page1) {
      this.page1.updated(configurations,AssetLibraryConstants.SEGMENTS,'segment');
    } else if (this.page2) {
      this.page2.updated(configurations,AssetLibraryConstants.SEGMENTS,'segment');
    } else {
      this.page3.updated(configurations,AssetLibraryConstants.SEGMENTS,'segment');
    }
  }

  sortBy(sortValue: string) {
    this.page = 1;
    switch (sortValue) {
      case AssetLibraryConstants.SORT_ORDER_SEGMANT_NAME: {
        this.sortValue = AssetLibraryConstants.SORT_ORDER_SEGMANT_NAME_LABEL;
        this.displaySegmentGroups.sort((segment1, segment2) =>
          segment1.configurations.publishedName.localeCompare(segment2.configurations.publishedName));
        break;
      }
      case AssetLibraryConstants.SORT_ORDER_RETAILER_NAME: {
        this.sortValue = AssetLibraryConstants.SORT_ORDER_RETAILER_NAME_LABEL;
        this.displaySegmentGroups.sort((segment1, segment2) =>
          segment1.configurations.retailerName.localeCompare(segment2.configurations.retailerName));
        break;
      }
      case GlobalConstants.CREATED_DATE: {
        this.displaySegmentGroups.sort((segment1, segment2) =>
          new Date(segment2.updateTime)?.getTime() - new Date(segment1.updateTime)?.getTime());
        break;
      }
      default:
        break;
    }
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal(segmentId: string) {
    this.segmentToDelete = this.displaySegmentGroups.find(ele => ele.id === segmentId).id;
    this.segmentToDeleteName = this.displaySegmentGroups.find(ele => ele.id === segmentId).configurations.publishedName;
    this.openModal(this.deleteModal);
  }

  openSendSegmentToAccountModal(segmentId: string) {
    this.sendButtonText = GlobalConstants.SEGMENT_BUTTON_TEXT;
    this.segmentIdInfo = segmentId;
    this.sendNameToStore = this.displaySegmentGroups.find(ele => ele.id === segmentId).configurations.publishedName;
    this.openModal(this.sendToAccountModal);
  }

  deleteSegment(segmentId: string) {
    // delete Promo API call
    this.segmentsService.deleteSegmentById(segmentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        // console.log('Delete Store Promo success --', deleteResponse);
        const index = this.displaySegmentGroups.findIndex(d => d.id === segmentId); // find index in your array
        if (index >= 0) {
          this.displaySegmentGroups.splice(index, 1); // remove element from array
          this.segmentHeading = this.displaySegmentGroups.length <= 1 ? 'Segment Group' : 'Segments Groups';
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          // do something
          // console.log('Delete Store Promo error --', error);
          this.closeModal(this.deleteModal);
        });
  }

  setIndex(value: number) {
    this.tabIndex = value;
  }

  setCreatedGrpID(data) {
    this.buttonName = this.segmentsService.buttonName;
    if (typeof data === 'object' && data.cancel) {
      this.setIndex(0);
      this.pages = {};
      this.editCheck = false;
    } else {
      this.contentGrpData = data; if (typeof this.contentGrpData.segment.configurations === 'string') {
        this.contentGrpData.segment.configurations = JSON.parse(this.contentGrpData.segment.configurations) as SegmentsConfiguration;
      }
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.showSegmentName = this.contentGrpData.segment.configurations.publishedName;
      this.clickable = true;
      // this.mediaObjects = [];
      this.setIndex(2);
    }
  }

  refreshSegmentdata() {
    this.getAllSegmentsByUser();
    this.setIndex(0);
    this.mediaObjects = [];
  }

  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(2);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(3);
    } else {
      this.pages.page3 = true;
      this.setIndex(4);
    }
    this.isPage3Created = this.checkPages();
    this.pagelen = Object.entries(this.pages).length;    
  }

  setPreviewLayout(data) {
    this.segmentLayout = data;
  }

  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }

    return false;
  }
  cancel() {
    this.dataService.setSegment(undefined);
    for (const each of this.displaySegmentGroups) {
      if (each.id === this.contentGrpData?.segment?.id) {
        if (typeof each.configurations === 'string') {
          each.configurations = JSON.parse(each.configurations);
        }
        break;
      }
    }
    this.getAllSegmentsByUser();
    this.setIndex(0);
    this.mediaObjects = [];
    this.pages = {};
    this.clickable = false;
    this.editCheck = false;
  }

  updateSegment() {
    const updateSegment: CreateSegmentsResponse = this.contentGrpData as CreateSegmentsResponse;
    // Once page is updated.
    const segment = updateSegment.segment;
    if (typeof segment.configurations !== 'string') {
      segment.configurations = JSON.stringify(segment.configurations);
    }
    this.segmentsService.editSegmentById(JSON.stringify(segment), updateSegment.segment.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putSegmentResponse: CreateSegmentsResponse) => {
        for (const each of this.mediaObjects) {
          if (each.uploaded) {
            await this.updateMedia(each);
          }
        }
        this.deviceExists = putSegmentResponse.segment.deviceExists;

        if (this.presentPage === this.profilePage) {
          this.openModal(this.showModal);
        } else if (this.editCheck && this.presentPage === this.assetsPage && this.deviceExists) {
          this.openModal(this.applyModal);
        } else {
          this.pages = {};
          this.clickable = false;
          this.setIndex(0);
          this.getAllSegmentsByUser();
        }
        this.editCheck = false;
      },
        error => {
        }
      );
  }

  updateMedia(each) {
    return new Promise((resolve, reject) => {
      this.segmentsService.editSegmentByPageId(each.media.fileObj,
        each.media.name.split('.')
          .pop(), each.id, each.pageNum.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((data) => {
          resolve(data);//To-Do: we should handle what if response code is other than 200
        },
          error => { // do something
          }
        );
    });
  }

  prepareMediaSet(res, segmentId) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = { id: segmentId, media: res.data.media, pageNum: res.number };
      if (res.data.media.fileObj !== '') {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj = { id: segmentId, media: res.data.media, pageNum: res.number, uploaded: true };
      if (res.data.media.fileObj !== '') {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }
  }

  checkExistance(data, key, compValue) {
    const checkJSON = { hasMatch: false, matchedIndex: -1 };
    for (let index = 0; index < data.length; index += 1) {
      if (data[index][key] === compValue) {
        checkJSON.hasMatch = true;
        checkJSON.matchedIndex = index;
        break;
      }
    }

    return checkJSON;
  }

  fontSizeNumber(size) {
    if (size === GlobalConstants.SMALL) { return GlobalConstants.NUMBER_12; }
    if (size === GlobalConstants.MEDIUM) { return GlobalConstants.NUMBER_14; }
    if (size === GlobalConstants.LARGE) { return GlobalConstants.NUMBER_16; }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return GlobalConstants.TWO_COL_RIGHT_ASSET;
    } else if (id === 2) {
      return GlobalConstants.TWO_COL_LEFT_ASSET;
    } else if (id === 3) {
      return GlobalConstants.ONE_COL_MID_ASSET;
    }
  }

  setLayout(selected) {
    this.segmentLayout = selected;
    this.cmnService.emitLayout(selected);
  }

  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.SEGMENTS + AssetLibraryConstants.SLASH +
          gId + AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 1,
      previewType: pageContent ? pageContent.previewType : '',
      idleExpFullscreenEnabled: pageContent ? pageContent.idleExpFullscreenEnabled : '',
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,
    };

    return this.pageGrpForm;
  }
  getFontSize(size) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  editSegment(segmentId: string) {
    this.pages = {};
    this.mediaObjects = [];
    const segmentToEdit = this.displaySegmentGroups.find(ele => ele.id === segmentId);
    this.dataService.setSegment(segmentToEdit);
    this.editCheck = true;
    for (const each of segmentToEdit.configurations?.contentGroupPages) {
      if (each.pageNum === 1) {
        this.pages.page1 = true;
      }
      if (each.pageNum === 2) {
        this.pages.page2 = true;
      }
      if (each.pageNum === 3) {
        this.pages.page3 = true;
      }
    }
    const tempSegment = segmentToEdit as Segment;
    this.pagelen = Object.entries(this.pages).length;
    this.contentGrpData = {
      segment: tempSegment,
      responseContext: {}
    }; // set data to cntGrpData to show in pages
    this.showSegmentName = segmentToEdit?.configurations?.publishedName;
    this.setIndex(1);
  }

  addSegment() {
    this.mediaObjects = [];
    this.selctedContGrpsForProfile.contentGrps = [];
    this.selctedContGrpsForProfile.showOnDevice = false;
    this.displaySegmentGroups.forEach(element => {
      element.showOnDevice = false;
      element.addToPackage = false;
    });
    this.dataService.setSegment(undefined);
    this.tabIndex = 1;
  }

  // Adding content group objects for profile
  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      segmentId: this.displaySegmentGroups[ind].id,
      showOnDevice: this.displaySegmentGroups[ind].showOnDevice
    });
  }

  setPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displaySegmentGroups[index].showOnDevice = this.displaySegmentGroups[index].addToPackage = value;
  }

  findIndexAndSetValue(setValueTo: string, keyName: string, setValueAs: any) {
    if (setValueTo === GlobalConstants.DISPLAY_SEGMENTS) {
      const checkInd = this.displaySegmentGroups.findIndex(d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.displaySegmentGroups[checkInd].showOnDevice = setValueAs;
    } else {
      const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps.findIndex
        (d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = setValueAs;
    }
  }

  removeShowonDevice() {
    this.displaySegmentGroups.forEach(element => {
      element.isChecked = false;
    });
    this.selctedContGrpsForProfile.showOnDevice = undefined;
    this.selctedContGrpsForProfile.contentGrps.forEach(value => {
      value['showOnDevice'] = false;
    })
  }
  addToProfile(eventObj: any, index: number, eventSource: string) {
    // for radio button selection
    if (eventSource === GlobalConstants.RADIO) {
      // if switching show on device one to others
      if (!this.selctedContGrpsForProfile.showOnDevice && this.displaySegmentGroups[index].addToPackage) {
        this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[index].id;
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.SEGMENT_ID, true);
        this.displaySegmentGroups[index].showOnDevice = true;
      } else if (this.selctedContGrpsForProfile.showOnDevice && this.displaySegmentGroups[index].addToPackage) {
        this.findIndexAndSetValue(GlobalConstants.DISPLAY_SEGMENTS, GlobalConstants.ID, false);
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.SEGMENT_ID, false);
        this.displaySegmentGroups[index].showOnDevice = true;
        this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[index].id;
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.SEGMENT_ID, true);
      } else {
        eventObj.target.checked = false;
      }
    } else if (eventSource === GlobalConstants.CHECK) {
      if (this.selctedContGrpsForProfile?.contentGrps?.length === 1 && (this.selctedContGrpsForProfile?.contentGrps[0]?.segmentId === undefined
        || this.selctedContGrpsForProfile?.contentGrps[0]?.segmentId === "")) {
        this.selctedContGrpsForProfile.contentGrps = [];
      }
      if (eventObj.target.checked) {
        if (this.selctedContGrpsForProfile.contentGrps?.length <= 9) {
          this.displaySegmentGroups[index].addToPackage = eventObj.target.checked;
          this.pushToSelectedGrps(index);
        } else {
          eventObj.target.checked = false;
        }
      } else {
        if (this.displaySegmentGroups[index].showOnDevice) {
          this.selctedContGrpsForProfile.showOnDevice = undefined;
        }
        this.setPackageNshowOnDeviceVal(index, false);
        const checkInd = this.selctedContGrpsForProfile.contentGrps.findIndex(d => d.segmentId === this.displaySegmentGroups[index].id);
        if (checkInd >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
        }
      }
    }
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      if (!this.selctedContGrpsForProfile?.contentGrps?.length) {
        this.selctedContGrpsForProfile.contentGrps = [{
          'segmentId': undefined,
          'showOnDevice': false,
        }];
      }
      this.cmnService.emitDataToProfile({ page: GlobalConstants.SEGMENTS, dataSet: this.selctedContGrpsForProfile.contentGrps });
      //gtm(google tag manager)
      window['dataLayer'].push({
        'segment_added': true
      });
    } else {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.SEGMENTS, dataSet: GlobalConstants.SKIP });
    }
    this.cmnService.scrollTopInitial();
  }

  duplicateAndEditSegment(segmentGroupId: string) {
    const segGrpToDuplicate = this.displaySegmentGroups.find(ele => ele.id === segmentGroupId);
    const promoContentConfig = segGrpToDuplicate.configurations;
    if (promoContentConfig?.publishTime && !promoContentConfig?.isPublishDateNow) {
      //changing it to old format
      promoContentConfig.publishTime = Utils.changeSaveDateFormat(promoContentConfig?.publishTime);
    }
    if (promoContentConfig?.expireTime && promoContentConfig?.expireTime !== GlobalConstants.NEVER) {
      //changing it to old format
      promoContentConfig.expireTime = Utils.changeSaveDateFormat(promoContentConfig?.expireTime);
    }
    const segmentToCreate: SegmentsConfiguration = {
      publishedName: `Copy of ${promoContentConfig.publishedName}`,
      internalName: promoContentConfig.internalName,
      retailerName: promoContentConfig.retailerName,
      segmentBgColor: promoContentConfig.segmentBgColor,
      segmentFontColor: promoContentConfig.segmentFontColor,
      publishTime: promoContentConfig.publishTime,
      expireTime: promoContentConfig.expireTime,
      contentScheduleTimezoneCode: promoContentConfig.contentScheduleTimezoneCode,
      type: promoContentConfig.type,
      contentGroupPages: promoContentConfig.contentGroupPages,
      formFactor: promoContentConfig.formFactor,
      isApplyToIpos: promoContentConfig.isApplyToIpos,
      isPublishDateNow: promoContentConfig.isPublishDateNow,
      isPublishExpiryNever: promoContentConfig.isPublishExpiryNever,
      iposBackgroundType: promoContentConfig.iposBackgroundType
    };

    this.segmentsService.createSegment(JSON.stringify(segmentToCreate))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createSegmentResponse => {
        this.getDetailsOfSegment(segmentGroupId);
        const createSegmentResponseObj: CreateSegmentsResponse = createSegmentResponse as CreateSegmentsResponse;
        const segmentViewModel: SegmentViewModel = createSegmentResponseObj.segment as unknown as SegmentViewModel;
        segmentViewModel.configurations = JSON.parse(createSegmentResponseObj.segment.configurations) as SegmentsConfiguration;
        if (segGrpToDuplicate.configurations && segGrpToDuplicate.configurations?.contentGroupPages) {
          for (let page of segGrpToDuplicate.configurations.contentGroupPages) {
            await this.duplicateSegmentImage(segGrpToDuplicate, segmentViewModel, page);
          }
        }
        if (segmentViewModel && segmentViewModel.configurations) {
          if (segmentViewModel.configurations?.publishTime && !segmentViewModel.configurations.isPublishDateNow) {
            //changing it to old format
            segmentViewModel.configurations.publishTime = Utils.ChangetoOldFormat(segmentViewModel.configurations.publishTime);
          }
          if (segmentViewModel.configurations.expireTime &&
            segmentViewModel.configurations.expireTime !== GlobalConstants.NEVER
          ) {
            //changing it to old format
            segmentViewModel.configurations.expireTime = Utils.ChangetoOldFormat(segmentViewModel.configurations.expireTime);
          }
        }
        this.dataService.setSegment(segmentViewModel);
        this.editCheck = true;
        for (let each of segmentViewModel.configurations.contentGroupPages) {
          if (each.pageNum === 1) {
            this.pages.page1 = true;
          }
          if (each.pageNum === 2) {
            this.pages.page2 = true;
          }
          if (each.pageNum === 3) {
            this.pages.page3 = true;
          }
        }
        this.contentGrpData = {
          segment: segmentViewModel,
          responseContext: {}
        };
        const tempViewModel: any = segmentViewModel;
        tempViewModel.createdByUser = (tempViewModel.createdByUser === this.userId) ? GlobalConstants.ME : tempViewModel.createdByUser;
        tempViewModel.isExpanded = false;
        tempViewModel.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        if (tempViewModel.updateTime) {
          tempViewModel.updateTime = new Date(tempViewModel.updateTime);
          tempViewModel.updateTimeDisplay = new Date(tempViewModel.updateTime).toLocaleString()
            .replace(',', '');
        }
        tempViewModel.addToPackage = tempViewModel.showOnDevice = false;
        this.displaySegmentGroups.unshift(tempViewModel);
        if (this.presentPage === this.profilePage) {
          this.displaySegmentGroups.forEach((element, index) => {
            element.index = index;
          });
        }
        this.sortBy(GlobalConstants.CREATED_DATE);
        this.showSegmentName = segmentToCreate.publishedName;
        this.page = 1;
        this.setIndex(1);
      },
        error => {
        }
      );
  }

  duplicateSegmentImage(segment: any, newSegment: any, page: any) {
    return new Promise((resolve, reject) => {
      if (page.linkedAsset) {
        this.segmentsService.getSegmentByPageId(segment.id, page.pageNum)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            this.segmentsService.editSegmentByPageId(imageData, 'png', newSegment.id, page.pageNum)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                resolve(data);//ToDo: Need to add reject too.
              },
                error => {
                });
          },
            error => {
            });
      } else {
        resolve({});//ToDo: just sending empty, to continue the flow;
      }
    });
  }

  redirectToList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.showModal);
    this.getAllSegmentsByUser();
  }

  redirectToApplyList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.applyModal);
    this.getAllSegmentsByUser();
  }

  showOnDevice() {
    this.showDevice = true;
    this.redirectToList();
  }

  applyToDevice(applyDevice: boolean) {
    const updateSegment: CreateSegmentsResponse = this.contentGrpData as CreateSegmentsResponse;
    // Once page is updated.
    const segment = updateSegment.segment;
    if (typeof segment.configurations !== 'string') {
      segment.configurations = JSON.stringify(segment.configurations);
    }
    segment.ispushedToDevice = applyDevice;
    segment.showOnDevice = applyDevice;
    if (!applyDevice) {
      segment.deviceExists = false;
    }
    else {
      segment.deviceExists = this.deviceExists;
    }
    this.segmentsService.editSegmentById(JSON.stringify(segment), updateSegment.segment.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putSegmentResponse: CreateSegmentsResponse) => {
        this.redirectToApplyList();
      },
        error => {

        });
  }

  closeApplynDevice() {
    this.redirectToApplyList();
    this.showDevice = false;
  }


  closeShowOnDevice() {
    this.redirectToList();
    this.showDevice = false;
    this.selctedContGrpsForProfile.contentGrps = [];
    this.selctedContGrpsForProfile.showOnDevice = false;
  }

  navigate() {
    this.isNavigated = true;
    if (this.contentGrpData.segment && this.contentGrpData.segment.configurations) {
      if (
        this.contentGrpData.segment.configurations?.publishTime &&
        !this.contentGrpData.segment.configurations.isPublishDateNow
      ) {
        //changing it to old format
        this.contentGrpData.segment.configurations.publishTime =
          Utils.ChangetoOldFormat(
            this.contentGrpData.segment.configurations.publishTime
          );
      }
      if (
        this.contentGrpData.segment.configurations.expireTime &&
        this.contentGrpData.segment.configurations.expireTime !== GlobalConstants.NEVER
      ) {
        //changing it to old format
        this.contentGrpData.segment.configurations.expireTime =
          Utils.ChangetoOldFormat(
            this.contentGrpData.segment.configurations.expireTime
          );
      }
    }
    this.newContentGrpDataToNavigate = this.contentGrpData;
    this.newContentGrpDataToNavigate.segment.configurations.formFactor =
      Utils.getFormFactorNames(this.newContentGrpDataToNavigate.segment.configurations.formFactor);
    this.dataService.setSegment(this.newContentGrpDataToNavigate.segment);
    this.setIndex(1);
    this.clickable = false;
  }
  tabTrimString(data: string) {
    return Utils.trimString(data)
  }

  getSelectedStoreData(data) {
    this.sendToStoreService.sendToStoreService(this.segmentIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {

          this.isSendToStore = true;
          this.getAllSegmentsByUser();
        }
      });
  }

  disableFields() {
    this.cmnService.previewTypeObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(type => {
      this.previewType = type;
    });
    return this.previewType;
  }

  togglePreviewTabs(previewType, id) {
    this.isIdleExperienceEnabled = previewType;
    this.displaySegmentGroups.forEach(element => {
      if (element.id === id) {
        element.isIdleExperienceEnabled = this.isIdleExperienceEnabled;
      }
    });
  }
}